export const enum PayCardReconciliationStatus {
  PENDING,
  REVIEWED,
  EXPORTED,
}
